// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__Ivo8N","footer":"ModalInfo_footer__21jmZ"};